import { Pipe, PipeTransform } from '@angular/core';
import escape from 'lodash/escape';

@Pipe({
    name: 'escapeHtml',
    standalone: false
})
export class EscapeHtmlPipe implements PipeTransform {
  public transform(text: string): string {
    return escape(text);
  }
}
